export default class MagicActionValidationRequest {
  constructor(obj) {
    if (!obj) obj = {};
    this.actionKey = obj.actionKey ? obj.actionKey : "";
    this.decryptKey = obj.decryptKey ? obj.decryptKey : 0;
  }
}
